import { TenantCurrency } from 'src/common/currency';
import { CashflowColumn } from '../components/CashflowTable';
import { amountCell, frequencyAmountCell } from '../components/cashflowCells';
import { labelForIncomeType } from '../incomeTypes';
import { NOT_RECORDED, dateOrNotRecorded } from '../notRecorded';
import { ExpenditureRow, IncomeRow, LifeEventRow, partialAmountNote } from '../rows';
import { Period } from '../utils';
import { AppliesToCell } from './AppliesToCell';
import { labelForExpenditureCategory } from './expenditureCategories';

export function incomeRowColumns(
  period: Period,
  currency: TenantCurrency,
): CashflowColumn<IncomeRow>[] {
  return [
    {
      key: 'incomeType',
      header: 'Type',
      renderValue: value => labelForIncomeType(String(value)),
    },
    {
      key: 'members',
      header: 'Applies to',
      renderValue: (_value, row) => <AppliesToCell members={row.members} />,
    },
    { key: 'description', header: 'Description' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: 'amountPreTax',
      header: `Before tax (${period})`,
      renderValue: (_value, row) =>
        frequencyAmountCell(period, row.amountPreTax, row.frequency, currency, {
          partialNote: partialAmountNote(row, item => item.amountPreTax),
        }),
    },
    {
      key: 'amountPostTax',
      header: `After tax (${period})`,
      renderValue: (_value, row) =>
        frequencyAmountCell(period, row.amountPostTax, row.frequency, currency, {
          partialNote: partialAmountNote(row, item => item.amountPostTax),
        }),
    },
  ];
}

export function expenditureRowColumns(
  period: Period,
  currency: TenantCurrency,
): CashflowColumn<ExpenditureRow>[] {
  return [
    {
      key: 'category',
      header: 'Category',
      renderValue: (_value, row) =>
        row.category ? labelForExpenditureCategory(row.category) : NOT_RECORDED,
    },
    {
      key: 'members',
      header: 'Applies to',
      renderValue: (_value, row) => <AppliesToCell members={row.members} />,
    },
    { key: 'description', header: 'Description' },
    { key: 'frequency', header: 'Frequency' },
    {
      key: 'amount',
      header: `Spend (${period})`,
      renderValue: (_value, row) =>
        frequencyAmountCell(period, row.amount, row.frequency, currency, {
          partialNote: partialAmountNote(row, item => item.amount),
        }),
    },
  ];
}

export function lifeEventRowColumns(currency: TenantCurrency): CashflowColumn<LifeEventRow>[] {
  return [
    { key: 'description', header: 'Description' },
    {
      key: 'members',
      header: 'Applies to',
      renderValue: (_value, row) => <AppliesToCell members={row.members} />,
    },
    {
      key: 'eventDate',
      header: 'Date',
      renderValue: (_value, row) => dateOrNotRecorded(row.eventDate),
    },
    { key: 'details', header: 'Details' },
    {
      key: 'cost',
      header: 'Amount',
      renderValue: (_value, row) =>
        amountCell(
          row.cost,
          currency,
          partialAmountNote(row, item => item.cost),
        ),
    },
  ];
}
